import Empty from '../../components/base/Empty';

const routes = [
  {
    path: '/user-action-log',
    to: '/roles/user-action-log',
    name: 'menu.user-action-log',
    icon: 'mon-event',
    customIcon: true,
    loginRequired: true,
    component: Empty,
    weight: 102,
    permission: ['frontend_menu_event_logs'],
    children: [],
    hideOnMenu: true,
    redirect: true,
  },
];

export default routes;
